import { z } from 'zod';

import { errorMessages } from '../entities/User/dialogs/constants/errorMessages';

export const schemaPrimeiroAcesso = z
  .object({
    password: z
      .string()
      .min(6, { message: 'A senha deve ter no mínimo 6 caracteres' }),
    confirmPassword: z.string().min(1, { message: 'Confirme a senha' }),
  })
  .refine(data => data.password === data.confirmPassword, {
    message: 'As senhas não conferem',
    path: ['confirmPassword'],
  });

export const schemaCreateUser = z
  .object({
    name: z
      .string()
      .min(1, { message: errorMessages.name.required })
      .max(50, { message: errorMessages.name.max }),
    email: z
      .string()
      .min(1, { message: errorMessages.email.required })
      .email({ message: errorMessages.email.invalid }),
    userMartins: z.string().optional(),
    roleId: z.number({
      invalid_type_error: errorMessages.roleId.required,
    }),
    advertisingId: z.union([z.string(), z.number()]).optional(),
    cpf: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const isFabrica = data.roleId === 4;
    if (isFabrica && !data.advertisingId) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.advertisingId.required,
        path: ['advertisingId'],
      });
    }
    if (!isFabrica && !data.userMartins) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.userMartins.required,
        path: ['userMartins'],
      });
    }
    if (isFabrica && !data.cpf) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.cpf.required,
        path: ['cpf'],
      });
    }
    if (data.cpf && !/^\d{11}$/.test(data.cpf)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.cpf.invalid,
        path: ['cpf'],
      });
    }
  });

export const schemaEditUser = z
  .object({
    name: z
      .string()
      .min(1, { message: errorMessages.name.required })
      .max(50, { message: errorMessages.name.max }),
    email: z
      .string()
      .min(1, { message: errorMessages.email.required })
      .email({ message: errorMessages.email.invalid }),
    roleId: z.number({
      invalid_type_error: errorMessages.roleId.required,
    }),
    cpf: z.string().optional(),
  })
  .superRefine((data, ctx) => {
    const isFabrica = data.roleId === 4;
    if (isFabrica && !data.cpf) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.cpf.required,
        path: ['cpf'],
      });
    }
    if (data.cpf && !/^\d{11}$/.test(data.cpf)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: errorMessages.cpf.invalid,
        path: ['cpf'],
      });
    }
  });
